import {ParamEnabledIcon} from "../Icons";
import React from "react";

export const Enabled = (props) => {
    return <span>{ParamEnabledIcon(props)}{props.enabled}</span>;
};


// WEBPACK FOOTER //
// ./src/components/results/Enabled.js